import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import { apolloClient as client } from "../data-provider/graphqlDataProvider";

let token: any = localStorage.getItem('credentials')
// const client = new ApolloClient({
//     uri: `${process.env.REACT_APP_DATAPROVIDER}`,
//     headers: { authorization: token },
//     cache: new InMemoryCache({
//         addTypename: false,
//         resultCaching: false
//     }),
//     defaultOptions: {
//         watchQuery: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'ignore',
//         },
//         query: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'all',
//         },
//     }
// });

// const partnerDiscountClient = new ApolloClient({
//     uri: `${process.env.REACT_APP_LEMONADE_SERVER}/partner-discount/graphql`,
//     headers: { authorization: token },
//     cache: new InMemoryCache({
//         addTypename: false,
//         resultCaching: false
//     }),
//     defaultOptions: {
//         watchQuery: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'ignore',
//         },
//         query: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'all',
//         },
//     }
// });
export async function createRule(params: any, id: any) {

    
    try {
        const { data } = await client.mutate({
            mutation: gql`
                mutation CreateRule($data: RuleCreateInput!) {
                    createRule(data: $data) { 
                        id
                    }
                }
            `,
            variables: {
                data: {
                    ...params,
                    product: {
                        connect: {
                            id: id
                        }
                    }
                }
            }
        });
        return data;
    } catch (error) {
        console.error('GraphQL error:', error);
        throw new Error('fail');
    }
}
export async function createProduct(params: any) {
    let data: any = params.data;
    console.log('create product: ', data);
    let attachment = data.attachment;   
    let logoUrl = data.logoUrl
    delete data.attachment;
    delete data.logoUrl;     
    delete data.partnerDiscountLogo;
    const CREATE_PRODUCT = gql`
    mutation CreateProduct($data: ProductCreateInput!){
        createProduct(data: $data) {
        id    
        }
    }
    `;
    let hasAllowedMentor = data.meta ? data.meta.hasOwnProperty("isAllowedMentor") : false
    data = {
        ...data,
        meta: {
            ...data.meta,
            orderTrackingUrl:data.meta?.orderTrackingUrl ? data.meta.orderTrackingUrl : null,
            paymentSuccessMessage:data.meta?.paymentSuccessMessage ? data.meta.paymentSuccessMessage : null,
            tags: data.meta?.tags ? data.meta.tags.map((t: any) => t.label) : [],
            isAllowedMentor: hasAllowedMentor ? data.meta.isAllowedMentor : false                              
        },
        images: logoUrl ? {logo: logoUrl} : {}  
    }
    console.log('create product data: ', data);
    return client.mutate({
        mutation: CREATE_PRODUCT,
        variables: {
            data: data
        }
    }).then((res) => {
        if (!res.data.errors) {
            console.log('create product: ', res.data);
            // if (attachment) {
            //     uploadPartnerDiscountFile(res.data.createProduct.id, attachment)
            // }
            return res;
        }
    }).catch(e => {
        console.log('error catch: ', e)
    })       
}

export async function getProduct(params: any) {
    const GET_Product = gql`
    query product($where: ProductWhereUniqueInput!){
      product(where: $where){       
    createdBy
    currency
    description
    expiryPeriod
    id
    isEnabled
    meta
    name
    offPercent
    offValue
    price
    productType
    service
    subtitle
    subtitle2
    title    
    updatedBy
    images
    rules {
        id
        isEnabled
   }
      }
    }
    `;
    return client.query({
        query: GET_Product,
        variables: {
            where: {
                id: params.id,
            
            }
        }
    })
}

export async function updateProduct(params: any) {
  
    
    const UPDATE_PRODUCT = gql`
            mutation UpdateProduct($where: ProductWhereUniqueInput!, $data: ProductUpdateInput!){
              updateProduct(data: $data, where: $where) {
                id    
                meta
                }
            }
          `;
    let productId = params.data.id
    delete params.data.id;
    
    delete params.data["__typename"]
    let data: any = params.data;      
    let logoUrl = data.logoUrl
    delete data.logoUrl;     
    delete data.partnerDiscountLogo;
    delete data.attachment;
   
    data = {
        ...data,
        meta: {
            ...data.meta,
            orderTrackingUrl:data.meta?.orderTrackingUrl ? data.meta.orderTrackingUrl : null,
            paymentSuccessMessage:data.meta?.paymentSuccessMessage ? data.meta.paymentSuccessMessage : null,
            tags: data.meta?.tags ? data.meta.tags.map((t: any) => t.label) : [],            
        },
        images: logoUrl ? {logo: logoUrl} : {} 
        // ...(logoUrl && {images: {logo: logoUrl}})
    }
   
    return client.mutate({
        mutation: UPDATE_PRODUCT,
        variables: {
            where: { id: productId },
            data: data
        }
    }).then((res) => {
        return res.data;

    }).catch(e => {
        console.log('error catch: ', e)
    })
}

export async function getProductList(params: any) {
    const GET_Products = gql`
    query GetProducts($where: ProductWhereInput, $orderBy: [ProductOrderByInput!], $skip: Float, $take: Float){
      products(where: $where, orderBy: $orderBy, skip: $skip, take:$take) {
        id
        title
        price
        currency
        meta
        isEnabled
        service
        offValue
        productType 
        images 
        rules {
            id
            isEnabled
        }      
      }
      _productsMeta(where: $where, orderBy: $orderBy, skip: $skip, take:$take){
        count
      }
    }
    `;
    let filterData = deleteNullPropertyValueDiscountFilter(params.filter)
    return client.query({
        query: GET_Products,
        variables: {
            where: {
                service: { equals: process.env.REACT_APP_SERVICE },
                ...filterData
            },
            skip: params.pagination.perPage * (params.pagination.page - 1),
            take: params.pagination.perPage,
            orderBy: { productType: "Asc" }
        }
    })
}

export const deleteNullPropertyValueDiscountFilter = (filter: any) => {
    let filterData = { ...filter }
    if (!filterData.id.contains)
        delete filterData.id
    if (!filterData.title.contains)
        delete filterData.title
    if(filter.productType.equals === "NONE" || !filter.productType.equals)
        delete filterData.productType
    if(!filter.isEnabled.equals)
        delete filterData.isEnabled
    if (filterData.tags.length === 0)
        delete filterData.tags
    else if (filterData.tags.length > 0) {       
        const tags = filterData.tags;
        delete filterData.tags  
        filterData.meta = { path: "tags", array_contains: tags.map((tag: any) => tag.label) }
    }

    console.log('deleteNullPropertyValueDiscountFilter: ', filterData);
    return filterData
}

export async function getActiveProductList() {
    const GET_Products = gql`
    query getActiveProducts($where:ProductWhereInput){
        products(where: $where){    
          id
          isEnabled
          meta
          offValue
          price
          title
          subtitle2
          service
          images
        }
      }
    `;

    return client.query({
        query: GET_Products,
        variables: {
            where: {
                service: { equals: process.env.REACT_APP_SERVICE },
                isEnabled: { equals: true }
            }
        }
    }).then((res: any) => {
        if (!res.err) {
            return res.data.products;
        }
    })
}

export async function createSmsMessage(productId: string, template: string) {
    const CREATE_SMS_TEMPLATE = gql`
    mutation CreatePartnerDiscountSmsTemplate($data: PartnerDiscountSmsTemplateCreateInput!){
        createOnePartnerDiscountSmsTemplate(data:$data) {
          id
          template
          productId
        }
      }
  `;

  return client.mutate({
        mutation: CREATE_SMS_TEMPLATE,
        variables: {
            data: {productId: productId, template: template}
        }
    })
}

export async function getSmsTemplate(productId: string) {
    const GET_SMS_TEMPLATE = gql`
    query findFirstSmsTemolate($where:PartnerDiscountSmsTemplateWhereInput){
        findFirstPartnerDiscountSmsTemplate(where: $where){
          id
          productId
          template
        }
      }
  `;

  return client.query({
        query: GET_SMS_TEMPLATE,
        variables: {
            where: {productId: {equals: productId}}
        }
    }).then((res: any) => {
        return res.data.findFirstPartnerDiscountSmsTemplate
    })
}

export async function updateSmsTemplate(productId: string, template: string){
    const UPDATE_SMS_TEMPLATE = gql`
    mutation updateSmsTemplate($data: PartnerDiscountSmsTemplateUpdateInput!, $where: PartnerDiscountSmsTemplateWhereUniqueInput!){
        updateOnePartnerDiscountSmsTemplate(data: $data, where: $where){
          id
          productId
          template
        }
      }
  `;

  return client.mutate({
        mutation: UPDATE_SMS_TEMPLATE,
        variables: {
            data: {template: { set: template}},
            where: { productId: productId}
        }
    })
}

export async function uploadPartnerDiscountFile(file: any, productId: string, attach: any) {    
    var formData = new FormData();       
    formData.append("file", file);
    formData.append("partnerProductId", productId);
    return axiosWithAuthInterceptor.post(`${process.env.REACT_APP_LEMONADE_SERVER}/api/partner-discounts`, formData, {
        headers: {
        'Content-Type': 'multipart/form-data',
        }
    }).then(res => {
        return res.data.count
    })

}

export async function uploadPartnerDiscountLogo(file: any) {
    console.log('uploadPartnerDiscountLogo file.rawFile: ', file)    
    var formData = new FormData();     
    formData.append("file", file);
    
    return await axiosWithAuthInterceptor.post(`${process.env.REACT_APP_LIMOOME_SERVER}/admin/document/ebcf0580-c023-4e87-aa23-7162a136e142`, formData, {
        headers: {
        'Content-Type': 'multipart/form-data',   
        }
    }).then(res => {        
        return res.data.fileName;
    })
}

const convertCsvToJson = (csv: any) => {
    const lines = csv.split('\n')
    const result = []
    const headers: Array<any> = []
    lines[0].split(',').forEach((h: any) => {
        headers.push(h.trim())
    });
    const discountList: Array<string> = []
    for (let i = 1; i < lines.length; i++) {
        if (!lines[i])
            continue
        const currentline = lines[i].split(',')
        discountList.push(currentline[0].trim())
    }
    return discountList;
}

// const getCsvFile = async (src: string) => {
//     let settlements: Array<any> = await axios.get(src)
//         .then((res: any) => {
//             let result = convertCsvToJson(res.data)
//             console.log('result: ', result);
//             return result;
//         })
// }


export async function rulesActivate() {    
    const data = {
        isEnabled: true,
        step: "BEFORE_SHOW_PRODUCT",
        ruleAddress: "http://localhost:3080/api/limoome-integrations/can-buy-diet"
    }
    return axiosWithAuthInterceptor.post(`${process.env.REACT_APP_LEMONADE_SERVER}/api/rules`, data).then(res => {
        return res
    })

}
export async function rulesPatch(param: any) {  
    console.log("rulesPatch param", param);
    
    const data = {
        isEnabled: param.rulesEnabled,
    };

    const config = {
        headers: {
            'Access-Control-Allow-Origin': '*', 
        },
    };

    return axiosWithAuthInterceptor.patch(
        `${process.env.REACT_APP_LEMONADE_SERVER}/api/rules/${param.id}`,
        data,
        config 
    ).then(res => {
        return res;
    });
}